<template>
	<div>

		<v-form ref="launch_form" v-if="wf_data">

			<div v-for="param in wf_data.parameters" :key="param.name">

				<div v-if="param.type.indexOf('char') === 0">
					<v-text-field
						:rules="get_validation_rules(param.type, param.required)"
						v-model="form.parameters[param.name]"
						@input="form_change()"
						:readonly="readonly"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('multi-char') === 0">
					<v-text-field
						:rules="get_validation_rules(param.type, param.required)"
						v-model="form.parameters[param.name]"
						@input="form_change()"
						:readonly="readonly"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('text') === 0">
					<v-textarea
						rows="2"
						auto-grow
						outline
						@input="form_change()"
						:readonly="readonly"
						:rules="get_validation_rules(param.type, param.required)"
						v-model="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-textarea>
				</div>

				<div v-else-if="param.type.indexOf('assetid') === 0">
					<v-text-field
						:rules="get_validation_rules(param.type, param.required)"
						v-model="form.parameters[param.name]"
						@input="form_change()"
						:readonly="readonly"
						:hint="get_hint(param)"
						append-icon="search"
						@click:append="showTitleAssetFinder(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('multi-assetid') === 0">
					<v-text-field
						:rules="get_validation_rules(param.type, param.required)"
						v-model="form.parameters[param.name]"
						@input="form_change()"
						:readonly="readonly"
						:hint="get_hint(param)"
						append-icon="search"
						@click:append="showTitleAssetFinder(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('url') === 0">
					<v-text-field
						:rules="get_validation_rules(param.type, param.required)"
						@input="form_change()"
						:readonly="readonly"
						v-model="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('email') === 0">
					<EmailField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:hint="get_hint(param)"
						:readonly="readonly"
						:multiple="false"
						@change="form.parameters[param.name] = $event; form_change()">
					</EmailField>
				</div>

				<div v-else-if="param.type.indexOf('multi-email') === 0">
					<EmailField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:hint="get_hint(param)"
						:readonly="readonly"
						:multiple="true"
						@change="form.parameters[param.name] = $event; form_change()">
					</EmailField>
				</div>

				<div v-else-if="param.type.indexOf('integer') === 0 ||
												param.type.indexOf('float') === 0">
					<v-text-field
						type="number"
						:rules="get_validation_rules(param.type, param.required)"
						@input="form_change()"
						:readonly="readonly"
						v-model.number="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('multi-integer') === 0">
					<v-text-field
						type="number"
						:rules="get_validation_rules(param.type, param.required)"
						@input="form_change()"
						:readonly="readonly"
						v-model="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('json') === 0">
					<div v-if="readonly" class="pb-2">
						<div class="py-1 px-2 background darken-2">
							{{ param.name }}
						</div>
						<AceJsonViewer :code="form.parameters[param.name]" :fold_level="2">
						</AceJsonViewer>
					</div>
					<div v-else>
						<v-textarea
							rows="5"
							auto-grow
							outline
							:rules="get_validation_rules(param.type, param.required)"
							@input="form_change()"
							class="dense_input"
							v-model="form.parameters[param.name]"
							:hint="get_hint(param)">
							<template v-slot:label>
								{{ param | maestroParamLabel }}
							</template>
						</v-textarea>
					</div>
				</div>

				<div v-else-if="param.type.indexOf('select') === 0">
					<v-autocomplete
						:items="param.choices"
						:rules="get_validation_rules(param.type, param.required)"
						@input="form_change()"
						:readonly="readonly"
						item-text="1"
						item-value="0"
						v-model="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-autocomplete>
				</div>

				<div v-else-if="param.type.indexOf('boolean') === 0">
					<v-checkbox
						:rules="get_validation_rules(param.type)"
						@change="form_change()"
						:readonly="readonly"
						v-model="form.parameters[param.name]"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-checkbox>
				</div>

				<div v-else-if="param.type.indexOf('directory') === 0 ||
												param.type.indexOf('file') === 0 ||
												param.type.indexOf('path') === 0">

					<v-text-field
						@change="pathCleaner(param.name)"
						:rules="get_validation_rules(param.type, param.required)"
						:ref="param.name"
						:readonly="readonly"
						v-model="form.parameters[param.name]"
						:prefix="getFileBasename(form.parameters[param.name])"
						class="file-input"
						:hint="get_hint(param)"
						:append-icon="'folder_open'"
						@click:append="showFileExplorer(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

				<div v-else-if="param.type.indexOf('multi-file') === 0 ||
												param.type.indexOf('multi-directory') === 0 ||
												param.type.indexOf('multi-path') === 0">
					<v-combobox
						v-model="form.parameters[param.name]"
						:items="form.parameters[param.name] || []"
						multiple
						chips
						:rules="get_validation_rules(param.type, param.required)"
						:ref="param.name"
						:readonly="readonly"
						:hint="get_hint(param)"
						class="file-input"
						:append-icon="'folder_open'"
						@click:append="showFileExplorer(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
						<template v-slot:selection="data">
							<v-chip
								:key="data.item"
								:selected="data.selected"
								:disabled="data.disabled"
								label small close
								color="primary color--text"
								@input="data.parent.selectItem(data.item)">
								{{ data.item }}
							</v-chip>
						</template>
					</v-combobox>
				</div>

				<div v-else-if="param.type.indexOf('operatingzone') === 0">
					<v-combobox
						v-model="form.parameters[param.name]"
						:items="param.choices.length ? param.choices : operating_zones_choices"
						:rules="get_validation_rules(param.type, param.required)"
						:ref="param.name"
						:return-object="false"
						item-text="1"
						item-value="0"
						:readonly="readonly"
						@change="form_change()"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-combobox>
				</div>

				<div v-else-if="param.type.indexOf('ownerid') === 0">
					<OwnerField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:readonly="readonly"
						:hint="get_hint(param)"
						@change="form.parameters[param.name] = $event; form_change()">
					</OwnerField>
				</div>

				<div v-else-if="param.type.indexOf('date') === 0">
					<DateField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:readonly="readonly"
						:hint="get_hint(param)"
						@change="form.parameters[param.name] = $event; form_change()">
					</DateField>
				</div>

				<div v-else-if="param.type.indexOf('datetime') === 0">
					<DatetimeField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:readonly="readonly"
						:hint="get_hint(param)"
						:title="param.name"
						@change="form.parameters[param.name] = $event; form_change()">
					</DatetimeField>
				</div>

				<div v-else-if="param.type.indexOf('babelid') === 0 ||
												param.type.indexOf('multi-babelid') === 0">
					<BabelIdField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:hint="get_hint(param)"
						:readonly="readonly"
						@change="form.parameters[param.name] = $event; form_change()">
					</BabelIdField>
				</div>

				<div v-else-if="param.type.indexOf('bundleid') === 0 ||
												param.type.indexOf('multi-bundleid') === 0">
					<BundleIdField
						:value="form.parameters[param.name]"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:hint="get_hint(param)"
						:readonly="readonly"
						@change="form.parameters[param.name] = $event; form_change()">
					</BundleIdField>
				</div>

				<div v-else-if="param.type.indexOf('patronid') === 0">
					<PatronIdField
						:value="form.parameters[param.name]"
						:ref="param.name"
						:rules="get_validation_rules(param.type, param.required)"
						:param="param"
						:hint="get_hint(param)"
						:readonly="readonly"
						@change="form.parameters[param.name] = $event; form_change()">
					</PatronIdField>
				</div>

				<div v-else>
					<v-text-field
						:rules="get_validation_rules('char', param.required)"
						v-model="form.parameters[param.name]"
						@input="form_change()"
						:readonly="readonly"
						:hint="get_hint(param)">
						<template v-slot:label>
							{{ param | maestroParamLabel }}
						</template>
					</v-text-field>
				</div>

			</div>

		</v-form>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

		<Explorer
			v-if="fileExplorer.visible"
			:multiselect="fileExplorer.multiple"
			:default_folder="working_dir || fileExplorer.default_value"
			:toolbarTitle="fileExplorer.destination_key"
			:assetType="fileExplorer.assetType"
			@close="fileExplorer.visible = false; fileExplorer.destination_key = null"
			@selectedAssets="explorerPath($event); fileExplorer.destination_key = null; form_change()">
			<h3 slot="header">Asset Select for Maestro ingester</h3>
		</Explorer>

		<TitleAssetFinder
			v-if="titleAssetFinder.visible"
			:multiselect="titleAssetFinder.multiselect"
			:toolbarTitle="titleAssetFinder.destination_key"
			@close="titleAssetFinder.visible = false; titleAssetFinder.destination_key = null"
			@selectedAssets="onAssetIdsSelected($event); titleAssetFinder.destination_key = null; form_change()">
			<h3 slot="header">Asset Select for Maestro ingester</h3>
		</TitleAssetFinder>

	</div>
</template>

<script>
import default_values from '@/pages/maestro/forms/job_or_task_form_default_values.js'
import Explorer from '@/components/modal_explorer.vue'
import TitleAssetFinder from '@/components/modal_title_asset_finder.vue'
import AceJsonViewer from '@/components/ace_json_viewer.vue'
import OwnerField from '@/components/field_owner.vue'
import DateField from '@/components/field_date.vue'
import DatetimeField from '@/components/field_datetime.vue'
import BabelIdField from '@/components/field_babel_id.vue'
import BundleIdField from '@/components/field_bundle_id.vue'
import PatronIdField from '@/components/field_patron_id.vue'
import EmailField from '@/components/field_email.vue'
import Path from 'path'

export default {
	name: '',
	props: ['debug', 'wf_data', 'details', 'readonly', 'param', 'saved_data'],
	components: {
		Explorer,
		TitleAssetFinder,
		AceJsonViewer,
		BabelIdField,
		BundleIdField,
		PatronIdField,
		OwnerField,
		DateField,
		DatetimeField,
		EmailField
	},
	data () {
		return {
			form: {
				isValid: false,
				jobdescriptorID: null,
				parameters: {}
			},
			fileExplorer: {
				visible: false,
				destination_key: null,
				assetType: 'file',
				default_value: null,
				multiple: false
			},
			titleAssetFinder: {
				visible: false,
				destination_key: null,
				multiselect: false
			},
			validations: {
				'email': v => /.+@.+/.test(v) || 'Mauvaise mise en forme de l\'email',
				'multi-email': v => this.multi_email_check(v) || 'Mauvaise mise en forme des emails',
				'integer': v => !v || Number.isInteger(v) || 'Nombre entier uniquement',
				'mutli-integer': v => this.multi_integer_check(v) || 'Nombres entiers uniquement',
				'json': v => this.json_check(v) || 'Mauvaise mise en forme JSON',
				'required': v => this.required_check(v) || 'Requis',
				'assetid': v => this.assetid_check(v) || 'Mauvais Asset id',
				'multi-assetid': v => this.multi_assetid_check(v) || 'Mauvais Asset ids',
				'babelid': v => this.babelids_check([v]) || 'ID introuvable',
				'multi-babelid': v => this.babelids_check(v) || 'ID introuvable'
			}
		}
	},
	watch: {
		wf_data: {
			handler: function (val) {
				if (!val) return
				this.form.isValid = false
				this.setParameters()
				this.$nextTick((arg) => {
					if (this.$refs.launch_form) {
						this.form.isValid = this.$refs.launch_form.validate()
						this.form_change()
					}
				})
			},
			deep: true
		},
		param: {
			handler: function (val) {
				if (!val) return
				if (!val.value) return
				this.form.isValid = false
				this.setParameters()
				this.$nextTick((arg) => {
					if (this.$refs.launch_form) {
						this.form.isValid = this.$refs.launch_form.validate()
						this.form_change()
					}
				})
			},
			deep: true
		}
	},
	computed: {
		maestroToUNC () {
			if (this.details.job_root) {
				return this.$paths.maestroToUNC(this.details.job_root)
			}
		},
		working_dir () {
			for (const key in this.details) {
				if (key.toLowerCase().indexOf('directory') > -1 ||
				key.toLowerCase().indexOf('folder') > -1) {
					return this.$paths.maestroToUNC(this.details[key])
				}
			}
			return ''
		},
		operating_zones_choices () {
			return this.$OpZones.map(zone => {
				return [zone.value, zone.text]
			})
		}
	},
	methods: {
		explorerPath (evt) {
			// add last slash if folder
			if (Array.isArray(evt)) {
				evt.map(item => {
					let maestroPath = this.$paths.UNCToMaestro(item.path)
					if (item.type === 'folder') {
						this.form.parameters[this.fileExplorer.destination_key].push(maestroPath + '/')
					} else {
						this.form.parameters[this.fileExplorer.destination_key].push(maestroPath)
					}
				})
			} else {
				let maestroPath = this.$paths.UNCToMaestro(evt.path)
				if (evt.type === 'folder') {
					this.form.parameters[this.fileExplorer.destination_key] = maestroPath + '/'
				} else {
					this.form.parameters[this.fileExplorer.destination_key] = maestroPath
				}
			}
		},

		onAssetIdsSelected (evt) {
			this.form.parameters[this.titleAssetFinder.destination_key] = evt
		},

		setParameters () {
			this.form.parameters = {}
			if (this.wf_data.parameters) {
				this.wf_data.parameters.map(desc => {
					let defaultValue = ''
					if (desc.default !== '') defaultValue = desc.default
					if (desc.type.indexOf('multi') === 0) defaultValue = []
					// prefill from hard coded values
					if (default_values.hasOwnProperty(this.wf_data.label)) {
						if (default_values[this.wf_data.label].hasOwnProperty(desc.name)) {
							defaultValue = default_values[this.wf_data.label][desc.name]
						}
					}
					// prefill from saved_data
					if (this.saved_data && Object.keys(this.saved_data).length > 0) {
						if (this.saved_data.hasOwnProperty(desc.name)) {
							if (desc.type === 'json' &&
								this.saved_data[desc.name] instanceof Object) {
								defaultValue = JSON.stringify(this.saved_data[desc.name], null, 2)
							} else {
								defaultValue = this.saved_data[desc.name]
							}
						}
					// prefill from context
					} else if (this.details) {
						if (this.details.hasOwnProperty(desc.name)) {
							if (desc.type === 'json' &&
								this.details[desc.name] instanceof Object) {
								defaultValue = JSON.stringify(this.details[desc.name], null, 2)
							} else {
								defaultValue = this.details[desc.name]
							}
						}
					}
					if (this.param) {
						if (this.param.type) {
							if (this.param.type.indexOf(desc.type) > -1) {
								defaultValue = this.param.value
							}
						}
					}
					this.form.parameters[desc.name] = defaultValue
				})
			}
			this.form_change()
		},

		get_validation_rules (fieldType, required) {
			let rules = []
			if (fieldType.indexOf('[') > -1) {
				fieldType = fieldType.substring(0, fieldType.indexOf('['))
			}
			if (this.readonly) return rules
			if ((required || required === undefined) && fieldType !== 'boolean') {
				// if required is not specified (undefined), it is true (as stated by Maestro)
				// do not apply 'required' rule to booleans,
				// or it won't be able to be a 'false' value
				rules.push(this.validations.required)
			}
			if (this.validations.hasOwnProperty(fieldType)) {
				rules.push(this.validations[fieldType])
			}
			return rules
		},

		getFileBasename (filepath) {
			try {
				return Path.basename(filepath)
			} catch (error) {
				return ''
			}
		},

		get_hint (param) {
			let hint = ''
			if (param.type) {
				hint = `[${param.type}] `
			}
			if (!('type' in param)) {
				// if param has no type it is a char (as stated by Maestro)
				hint = '[char] '
			}
			if (param.help) {
				hint += param.help
			}
			if (param.type && param.type.indexOf('multi-') > -1) {
				if (param.type.indexOf('email') === -1) {
					hint += ' (séparés par des virgules)'
				}
			}
			return hint
		},

		validateAgainst () {
			return new Promise(async (resolve, reject) => {
				let AgainstValidations = []
				for (let i = 0; i < this.wf_data.parameters.length; i++) {
					const param = this.wf_data.parameters[i]
					let conditionsIN = param.type.indexOf('[')
					let conditionsOUT = param.type.indexOf(']')
					let hasCondition = conditionsIN < conditionsOUT
					if (!hasCondition) continue
					let conditions = param.type.substring(conditionsIN + 1, conditionsOUT)
					if (conditions.indexOf('validate_against=') !== -1) {
						let AgainstValid = conditions.match(/validate_against=".+"/)
						if (AgainstValid) {
							let AgainstValidIN = AgainstValid[0].indexOf('"')
							let AgainstValidOUT = AgainstValid[0].lastIndexOf('"')
							if (AgainstValidIN < AgainstValidOUT) {
								AgainstValid = AgainstValid[0].substring(
									AgainstValidIN + 1,
									AgainstValidOUT
								).split(',').map(item => item.trim()).join(',')
								AgainstValidations.push({
									param_name: param.name,
									validate_against: AgainstValid
								})
							}
						}
					}
				}

				if (AgainstValidations.length === 0) resolve(true)

				let params = this.$commons.arrayToObject(this.wf_data.parameters, 'name')

				for (const item of AgainstValidations) {
					let inputFieldComp = this.$commons.deepGet(
						this.$refs,
						[item.param_name, 0],
						null
					)
					if (inputFieldComp) {
						inputFieldComp.validation_infos = {}
						inputFieldComp.errors = []
					}
					let patron = this.form.parameters[item.param_name]
					if (params.hasOwnProperty(item.validate_against)) {
						let against = this.form.parameters[item.validate_against]
						if (Array.isArray(against)) against = against.join(',')
						if (typeof (against) === 'string') {
							against = against.replace(/ /g, '')
						}
						if (against && patron) {
							let query = null
							let validateAgainstType = params[item.validate_against].type
							if (validateAgainstType.indexOf('bundleid') === 0) {
								query = `bundle=${against}`
							} else if (validateAgainstType.indexOf('assetid') === 0 ||
								validateAgainstType.indexOf('multi-assetid') === 0) {
								query = `asset_ids=${against}`
							}
							if (query) {
								try {
									let res = await this.$ApiAcme.patron_apply(patron, query)
									if (!res.data.is_valid) {
										if (inputFieldComp) {
											let errors = res.data.manual_proposals.join(' - ')
											inputFieldComp.errors = errors
											inputFieldComp.validation_infos = res.data
										}
									}
								} catch (error) {
									console.error('error', error)
								}
							}
						}
					} else {
						let assetsRE = /((maestro|suifa)-\d+)*/g
						let bundleRE = /bundle-\d+/g
						let query = null
						if (assetsRE.test(item.validate_against)) {
							let ids = item.validate_against
								.match(assetsRE)
								.filter(assetid => assetid)
								.join(',')
							query = `asset_ids=${ids}`
						} else if (bundleRE.test(item.validate_against)) {
							let ids = item.validate_against
								.match(bundleRE)
								.filter(assetid => assetid)
							if (ids[0]) query = `bundle=${ids[0]}`
						}
						if (query && patron) {
							try {
								let res = await this.$ApiAcme.patron_apply(patron, query)
								if (!res.data.is_valid) {
									if (inputFieldComp) {
										let errors = res.data.manual_proposals.join(' - ')
										inputFieldComp.errors = errors
										inputFieldComp.validation_infos = res.data
									}
								}
							} catch (error) {
								console.error('error', error)
							}
						}
					}
				}
				resolve(true)
			})
		},

		form_change () {
			this.$forceUpdate()
			this.$nextTick(async () => {
				try {
					await this.validateAgainst()
				} catch (error) {
					console.error(error)
				}
				this.form.jobdescriptorID = this.wf_data.descriptor_id
				this.form.jobDescriptorVersion = this.wf_data.version_number
				this.form.isValid = this.$refs.launch_form.validate()
				for (let i = 0; i < this.$refs.launch_form.inputs.length; i++) {
					if (this.$refs.launch_form.inputs[i].hasError) {
						this.form.isValid = false
						break
					}
				}
				this.$emit('change', [this.form])
			})
		},

		json_check (str) {
			if (!str) return true
			try {
				JSON.parse(str)
				return true
			} catch (e) {
				return false
			}
		},

		multi_email_check (value) {
			let isValid = true
			if (value) {
				let arr = value
				if (!Array.isArray(value)) arr = value.split(',')
				arr.map(email => {
					if (!/.+@.+/.test(email)) isValid = false
				})
			}
			return isValid
		},

		multi_assetid_check (value) {
			let isValid = true
			if (value) {
				let arr = value
				if (!Array.isArray(value)) arr = value.split(',')
				arr.map(assetid => {
					if (!/(maestro|suifa)-\d+/.test(assetid)) isValid = false
				})
			}
			return isValid
		},

		assetid_check (value) {
			let isValid = true
			if (value) {
				if (!/(maestro|suifa)-\d+/.test(value)) isValid = false
			}
			return isValid
		},

		babelids_check (babelids) {
			let isValid = true
			if (babelids) {
				let arr = babelids
				if (!Array.isArray(babelids)) arr = babelids.split(',')
				arr.map(babelid => {
					if (!Number.isInteger(babelid)) isValid = false
				})
			}
			return isValid
		},

		required_check (value) {
			if (value === '') return false
			if (value === null) return false
			if (value === undefined) return false
			if (Array.isArray(value)) {
				if (value.length === 0) return false
			}
			return true
		},

		showFileExplorer (param) {
			if (this.readonly) return
			this.fileExplorer.multiple = param.type.indexOf('multi-') === 0
			if (param.type === 'directory' || param.type === 'multi-directory') {
				this.fileExplorer.assetType = 'folder'
			} else if (param.type === 'file' || param.type === 'multi-file') {
				this.fileExplorer.assetType = 'file'
			} else {
				this.fileExplorer.assetType = null
			}
			this.fileExplorer.destination_key = param.name
			this.fileExplorer.default_value = null
			if (param.default) {
				this.fileExplorer.default_value = this.$paths.maestroToUNC(param.default)
			}
			this.fileExplorer.visible = true
		},

		showTitleAssetFinder (param) {
			this.titleAssetFinder.destination_key = param.name
			this.titleAssetFinder.multiselect = param.type === 'multi-assetid'
			this.titleAssetFinder.visible = true
		},

		multi_integer_check (str) {
			let isValid = true
			if (str) {
				str.split(',').map(number => {
					let int = parseInt(number, 10)
					if (!Number.isInteger(int)) isValid = false
				})
			}
			return isValid
		},

		pathCleaner (paramName) {
			let path = this.form.parameters[paramName]
			path = path.trim()
			if (path[0] === '"') {
				path = path.slice(1)
			}
			if (path[path.length - 1] === '"') {
				path = path.slice(0, path.length - 1)
			}
			let newPath = path.replace(/\\/g, '/')
			if (newPath.toLowerCase().indexOf('/media/data') > -1) {
				newPath = this.$paths.maestroToUNC(newPath)
			}
			let maestroPath = this.$paths.UNCToMaestro(newPath)
			this.$set(this.form.parameters, paramName, maestroPath)
			this.form_change()
		}
	},
	mounted () {
		this.setParameters()
	}
}
</script>

<style scoped lang="stylus">
.file-input
	>>>.v-text-field__slot
	>>>.v-select__slot
		.v-text-field__prefix
			font-size: 16px
			font-weight: 600
			min-width: fit-content
		input
			font-size: 12px
			padding-bottom: 4px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/forms/job_or_task_form.vue